// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dx2BF","label":"styles_label__2bVjw"};